import { createSlice } from "@reduxjs/toolkit";


const Login=createSlice({
    name:"Login",
    initialState:{
        Login:""
    },reducers:{
        SetLogin:(state,action)=>{
            state.Login=action.payload
        }
    }
})


export const {SetLogin}=Login.actions;
export default Login.reducer;